import { GraphQLResult, GRAPHQL_AUTH_MODE } from "@aws-amplify/api-graphql";
import { API } from "aws-amplify";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Account, CheckAccountStateQuery } from "../API";
import { useAppSelector } from "../app/hooks";
import { selectPlayer, setBalance } from "../features/player/playerSlice";
import { checkAccountState } from "../graphql/queries";
/**
 * Hook account (conto del player)
 * @returns Account, number, number
 */
const useAccount = () => {
  const dispatch = useDispatch();
  const player = useAppSelector(selectPlayer);
  const [account, setAccount] = useState<Account | null>(null);

  const [accountBalance, setAccountBalance] = useState<number>(0);

  const [withdrawable, setWithdrawable] = useState(0);

  const [bonus, setBonus] = useState(0);

  const [error, setError] = useState<any | null>(null);

  const getData = async () => {
    const result: GraphQLResult<CheckAccountStateQuery> = (await API.graphql({
      query: checkAccountState,
      authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
      variables: {},
    })) as GraphQLResult<CheckAccountStateQuery>;
    if (!result.errors) {
      setAccount({ ...result.data.checkAccountState });
      const deposit = parseFloat(
        result.data.checkAccountState.deposit.toFixed(2)
      );
      const expenses = parseFloat(
        result.data.checkAccountState.expenses.toFixed(2)
      );
      const winnings = parseFloat(
        result.data.checkAccountState.winnings.toFixed(2)
      );
      const pickedUp = parseFloat(
        result.data.checkAccountState.pickedUp.toFixed(2)
      );
      const bonus = parseFloat(result.data.checkAccountState.bonus.toFixed(2));
      // console.log("deposit", deposit);
      // console.log("expenses", expenses);
      // console.log("winnings", winnings);
      // console.log("pickedUp", pickedUp);
      // console.log("bonus", bonus);
      // console.log(
      //   "balance",
      //   Number(deposit) +
      //     Number(bonus) -
      //     Number(expenses) +
      //     Number(winnings) -
      //     Number(pickedUp)
      // );
      setAccountBalance(deposit + bonus - expenses + winnings - pickedUp);
      setBonus(bonus);
      if (
        deposit + bonus - expenses + winnings - pickedUp > 0 &&
        winnings > pickedUp
      )
        setWithdrawable(winnings - pickedUp);
      else setWithdrawable(0);
    } else {
      setError(result.errors);
    }
  };

  const accountRefresh = () => {
    (async () => {
      await getData();
    })();
  };

  useEffect(() => {
    // console.log("setAccountBalance", accountBalance);
    if (accountBalance) {
      dispatch(setBalance(accountBalance));
    }
  }, [accountBalance]);

  useEffect(() => {
    (async () => {
      if (player.logged) await getData();
    })();
  }, []);

  return { account, accountBalance, withdrawable, accountRefresh };
};

export default useAccount;
